module.exports = __webpack_public_path__ + "img/project.6c0cb814.png";